<script setup>

import {computed} from "vue";
import {usePage} from "@inertiajs/vue3";
import {Link} from '@inertiajs/vue3';
import axios from "axios";
import { inject, ref, provide } from "vue";

const themes = computed(() => usePage().props.themes);
const recentPosts = computed(() => usePage().props.recent_data);


async function onShowDialog(id) {
    await axios.get(route('update.count'),{
        params: {
            id: id,
        },
    });
}

const setAudioSource = inject('setAudioSource');

function playAudio(id, title, image, link_url) {
    setAudioSource(id, title, image, link_url);
    onShowDialog(id);
}

</script>

<template>

    <div class="container pa-0 mt-4">
        <h4 class="mt-3" style="font-size: 20px">{{ $t('share.recent') }}</h4>

        <div v-for="(post,index) in recentPosts" v-bind:key="index">
            <div class="py-2 d-flex align-items-center justify-content-start" v-if="post.format==='audios'" @click="playAudio(post.id, post.title, post.image, post.link_url)">
                        <v-card flat width="70" height="70" class="position-relative small-image mr-2">
                            <img @click="onShowDialog(post.id)" :src="post.image ? getImage(post.image) : '/assets/img/sub-article.png'" alt="Buddha Image" class="media-img w-100 h-100 object-fit-cover">
                            <div class="play-button">
                                <img src="/assets/img/logo-youtube.png" alt="Buddha Image" style="width: 30px; height: 30px; object-fit: cover;">
                            </div>
                        </v-card>
                        <div class="pl-1 w-66">
                            <h6 @click="onShowDialog(post.id)" class=" title-text text-black mb-2">{{ getTitle(post.title, 50) }}</h6>
<!--                            <div class="subtitle-text one-line-text">{{ post.format }} - {{ post.first_name }}</div>-->
<!--                            <div class="small-text one-line-text">{{ humanDate(post.updated_at) }}</div>-->
                            <Link :key="category.id" v-for="category in post.categories" :href="route('category', category.slug)"><span> {{ category.name }}</span></Link>

                        </div>
                    </div>

            <v-divider class="ma-0" v-if="index > 0"></v-divider>
          
            <v-dialog max-width="800" hight="100%" class="flex items-stretch" v-if="post.format==='videos'"
                   >
                <template v-slot:activator="{ props: activatorProps }">
                    <div class="py-2 d-flex align-items-center justify-content-start" v-bind="activatorProps">
                        <v-card flat width="70" height="70" class="position-relative small-image mr-2">
                            <img  @click="onShowDialog(post.id)" :src="post.image ? getImage(post.image) : '/assets/img/sub-article.png'" alt="Buddha Image" class="media-img w-100 h-100 object-fit-cover">
                            <div class="play-button">
                                <img src="/assets/img/logo-youtube.png" alt="Buddha Image" style="width: 30px; height: 30px; object-fit: cover;">
                            </div>
                        </v-card>
                        <div class="pl-1 w-66">
                            <h6  @click="onShowDialog(post.id)" class="title-text text-black mb-2">{{ getTitle(post.title, 50) }}</h6>
                            <Link :key="category.id" v-for="category in post.categories" :href="route('category', category.slug)"><span> {{ category.name }}</span></Link>

                            <!--                            <div class="subtitle-text one-line-text">{{ post.format }} - {{ post.first_name }}</div>-->
<!--                            <div class="small-text one-line-text">{{ humanDate(post.updated_at) }}</div>-->
                        </div>
                    </div>

                </template>

                <template v-slot:default="{ isActive }">
                    <v-card>
                        <iframe width="100%" height="500" :src="'https://www.youtube.com/embed/'+ post.link_url +'?si=beajwk0lgRip4bOO'"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                    </v-card>
                </template>

            </v-dialog>

            <Link v-if="post.format==='others' || post.format==='news' || post.format==='books'" :href="route('detail', post.id)">
                <div class="py-2 d-flex align-items-center justify-content-start" >
                    <v-card flat width="70" height="70" class="mr-2">
                        <img :src="post.image ? getImage(post.image) : '/assets/img/sub-article.png'" alt="Buddha Image" class="media-img w-100 h-100 object-fit-cover">
                    </v-card>
                    <div class="pl-1 w-66">
                        <h6 class="title-text text-black mb-2">{{ getTitle(post.title, 60) }}</h6>
                        <Link :key="category.id" v-for="category in post.categories" :href="route('category', category.slug)"><span> {{ category.name }}</span></Link>

                        <!--                        <div class="subtitle-text one-line-text">{{ post.format }} - {{ post.first_name }}</div>-->
<!--                        <div class="small-text one-line-text">{{ humanDate(post.updated_at) }}</div>-->
                    </div>
                </div>
            </Link>
        </div>
        <FloatingAudioPlayer
            :id="audioId" 
            :title="audioTitle" 
            :link_url="audioUrl" 
            :image="audioImage" 
        />
    </div>
</template>

<style scoped>
.one-line-text {
  display: -webkit-box;
  -webkit-line-clamp: 1; /* Limit to two lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.media-item {
    border-bottom: 1px solid #ddd;
    padding: 15px 0;
}

.media-img {
    width: 80px;
    height: 80px;
    /* object-fit: cover; */
    border-radius: 10px;
    margin-right: 15px;
}

.subtitle-text {
    color: #6c757d; /* Muted gray */
    font-size: 14px;
}

.small-text {
    font-size: 12px;
    color: #6c757d;
}
</style>
